import { Component, ViewModel, ObservableArray, View } from "binder";
import moment = require("moment");
import { getAsNumber } from "../utilities";
import { SplittedDateSelectorView } from "./splittedDateSelector-view"
import { translate } from "src/common/utilities";

declare function persianDate(): void;
declare function persianDate(any): void;

export class SplittedDateSelectorViewModel extends Component {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.years = ObservableArray.create<DateItem>();
        this.monthes = ObservableArray.create<DateItem>();
        this.days = ObservableArray.create<DateItem>();

        this.years.update(...([...new Array(200)].map((x, i) => {
            let y = new DateItem(this);
            y.value = (i + 1300);
            y.text = y.value.toString();
            return y;
        })));
        this.monthes.update(...[
            this.getDateMonthItem(1, translate("splittedDateSelector-viewModel.january", {})),
            this.getDateMonthItem(2, translate("splittedDateSelector-viewModel.february", {})),
            this.getDateMonthItem(3, translate("splittedDateSelector-viewModel.march", {})),
            this.getDateMonthItem(4, translate("splittedDateSelector-viewModel.april", {})),
            this.getDateMonthItem(5, translate("splittedDateSelector-viewModel.may", {})),
            this.getDateMonthItem(6, translate("splittedDateSelector-viewModel.june", {})),
            this.getDateMonthItem(7, translate("splittedDateSelector-viewModel.july", {})),
            this.getDateMonthItem(8, translate("splittedDateSelector-viewModel.august", {})),
            this.getDateMonthItem(9, translate("splittedDateSelector-viewModel.september", {})),
            this.getDateMonthItem(10, translate("splittedDateSelector-viewModel.october", {})),
            this.getDateMonthItem(11, translate("splittedDateSelector-viewModel.november", {})),
            this.getDateMonthItem(12, translate("splittedDateSelector-viewModel.december", {})),
        ]);
        this.selectedYear = this.years.filter(x => x.value == new persianDate().year().toString())[0];
        this._allDays = ObservableArray.create<DateItem>();
        this._allDays.update(...([...new Array(31)].map((x, i) => {
            let y = new DateItem(this);
            y.value = i + 1;
            y.text = y.value.toString();
            return y;
        })));
    }
    GetDefaultView(): View<ViewModel> {
        return new SplittedDateSelectorView();
    }
    public getTypeId(): string {
        return "VM-6AC68B14-C958-446D-99D7-4082471405BD"
    }

    private _allDays: ObservableArray<DateItem>;
    public set defaultyear(v: number) {
        this._defaultyear = getAsNumber(v, true);
        if (this.date == null) {
            this.selectedYear = this.years.filter(x => x.value == this._defaultyear)[0];
        }
    } public get defaultyear(): number { return this._defaultyear; } private _defaultyear: number;

    public set years(v: ObservableArray<DateItem>) { this._years = v; } public get years(): ObservableArray<DateItem> { return this._years; } private _years: ObservableArray<DateItem>;
    public set monthes(v: ObservableArray<DateItem>) { this._monthes = v; } public get monthes(): ObservableArray<DateItem> { return this._monthes; } private _monthes: ObservableArray<DateItem>;
    public set days(v: ObservableArray<DateItem>) { this._days = v; } public get days(): ObservableArray<DateItem> { return this._days; } private _days: ObservableArray<DateItem>;
    public set selectedYear(v: DateItem) {
        this._selectedYear = v;
        this.updateDays();
        this.updateDate();
    } public get selectedYear(): DateItem { return this._selectedYear; } private _selectedYear: DateItem;
    public set selectedMonth(v: DateItem) {
        this._selectedMonth = v;
        this.updateDays();
        this.updateDate();
    } public get selectedMonth(): DateItem { return this._selectedMonth; } private _selectedMonth: DateItem;
    public set selectedDay(v: DateItem) { this._selectedDay = v; this.updateDate(); } public get selectedDay(): DateItem { return this._selectedDay; } private _selectedDay: DateItem;

    public set date(v: moment.Moment) {
        this._date = v;
        let p = new persianDate(v.toDate());

        this.isUpdating = true;
        this.selectedYear = this.years.filter(x => x.value == p.year())[0];
        this.selectedMonth = this.monthes[p.month() - 1];
        this.selectedDay = this.days[p.date() - 1];

        this.isUpdating = false;
    } public get date(): moment.Moment { return this._date; } private _date: moment.Moment;
    private getWeekDay(year: number, month: number, day: number) {
        let p = new persianDate([year, month, day]);
        let result = (<any>persianDate).rangeName().weekdays[p.day() - 1];
        return result;
    }
    updateDays() {
        if (this.selectedYear == null || this.selectedMonth == null) {
            this.days.clear();
        } else {
            let days = new persianDate([this.selectedYear.value, this.selectedMonth.value]).daysInMonth();
            this.days.update(...this._allDays.slice(0, days));
            this.days.forEach(x => {
                x.text = `${x.value} - ${this.getWeekDay(this.selectedYear.value, this.selectedMonth.value, x.value)}`;
            });
            if (this.selectedDay != null) {
                let lst = this.days.filter(x => x.value == this.selectedDay.value);
                if (lst.length == 0)
                    this.selectedDay = null;
                else
                    this.selectedDay = lst[0]
            }
        }
    }
    private isUpdating: boolean;
    updateDate() {
        if (this.isUpdating === true)
            return;
        if (this.selectedYear != null && this.selectedMonth != null && this.selectedDay != null) {
            let p: Date = new persianDate([this.selectedYear.value, this.selectedMonth.value, this.selectedDay.value]).toDate();
            this.date = moment.utc([p.getFullYear(), p.getMonth(), p.getDate()]);
        }
    }

    getDateMonthItem(value: number, text: string) {
        let result = new DateItem(this);
        result.text = text;
        result.value = value;
        return result;
    }
}
export class DateItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set text(v: string) { this._text = v; } public get text(): string { return this._text; } private _text: string;
    public set value(v: number) { this._value = v; } public get value(): number { return this._value; } private _value: number;
}